import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBXURTF9wc6esCx0b0qPhU0sHjgmy5b7Tg",
  authDomain: "winto1.firebaseapp.com",
  databaseURL: "https://winto1-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "winto1",
  storageBucket: "winto1.appspot.com",
  messagingSenderId: "376660589831",
  appId: "1:376660589831:web:a54df3fb787cc0ceac19a2",
  measurementId: "G-VQ4GQ2B8QZ"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();

export const appleProvider = new OAuthProvider("apple.com");

